export default __webpack_public_path__ + "static/media/capriciossa.97ddd123.png";